(() => {
  'use strict';
  const configElement = document.getElementById('ss-gift-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const strings = JSON.parse(document.getElementById('ss-gift-strings').textContent);
  const dialog = document.getElementById('ss-gift-dialog');
  const template = document.getElementById('ss-gift-cart-template');
  const masks = config.masks.filter(mask => mask.id && mask.variantId);
  if (!dialog || masks.length !== 4) return;
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const maskIds = new Set(masks.map(mask => Number(mask.id)));
  const maskVariantIds = new Set(masks.map(mask => String(mask.variantId)));
  const storageKey = 'sneaktix.halloween.mask';
  let state = config.state;
  let observed = signature(state.cart);
  let work = Promise.resolve();
  let busy = false;
  let lastFocus = null;
  let pending = '';
  try { pending = sessionStorage.getItem(storageKey) || ''; } catch {}

  function remember(value) {
    pending = String(value || '');
    try {
      if (pending) sessionStorage.setItem(storageKey, pending);
      else sessionStorage.removeItem(storageKey);
    } catch {}
  }

  function signature(cart) {
    return JSON.stringify([cart.total_price, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]);
  }

  function gifts(cart) {
    return cart.items.filter(item => maskIds.has(Number(item.product_id)));
  }

  async function readState() {
    const url = new URL(root, location.origin);
    url.searchParams.set('section_id', 'ss-halloween-gift-state');
    const response = await fetch(url.toString(), {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error(strings.error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const element = html.querySelector('[data-ss-gift-state]');
    if (!element) throw new Error(strings.error);
    return JSON.parse(element.textContent);
  }

  async function update(updates) {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
      bubbles:true,detail:{sections}
    }));
    const response = await fetch(root + 'cart/update.js', {
      method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({updates,sections:[...new Set(sections)].slice(0,5),sections_url:location.pathname})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || strings.error);
    if (window.FoxTheme?.pubsub && result.sections) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {cart:result});
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
    }
    return result;
  }

  function showStatus(message) {
    dialog.querySelector('[data-ss-gift-status]').textContent = message || '';
  }

  function cleanHalloweenDiscountLabels() {
    document.querySelectorAll('cart-drawer .cart-item__discounts .discount').forEach(label => {
      const title = label.textContent.replace(/\\s+/g, ' ').trim().toLowerCase();
      if (title.includes('halloween') && title.includes('masque') && title.includes('commande')) {
        label.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function cleanGiftDrawerLines() {
    document.querySelectorAll('cart-drawer .cart-item[data-variant-id]').forEach(line => {
      const isGift = maskVariantIds.has(line.dataset.variantId);
      const shouldHide = isGift && gifts(state.cart).some(item => String(item.variant_id) === line.dataset.variantId && item.final_line_price === 0);
      line.classList.toggle('ss-gift-duplicate-line', shouldHide);
      line.hidden = shouldHide;
    });
  }

  function paint() {
    cleanGiftDrawerLines();
    cleanHalloweenDiscountLabels();
    const gift = gifts(state.cart)[0];
    const model = gift && masks.find(mask => Number(mask.variantId) === Number(gift.variant_id));
    const free = gift && gift.final_line_price === 0;
    const selectedId = gift ? String(gift.variant_id) : pending;
    dialog.querySelectorAll('[data-ss-gift-pick]').forEach(button => {
      const selected = button.dataset.ssGiftPick === selectedId;
      const available = masks.some(mask => String(mask.variantId) === button.dataset.ssGiftPick && mask.available);
      button.disabled = busy || !available || (state.pairs < 1 && !config.productEligible);
      button.setAttribute('aria-pressed', String(selected));
      button.querySelector('.ss-gift-card-action').textContent = selected ? strings.selected : strings.choose;
    });
    document.querySelectorAll('[data-st-gift-preview]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.stGiftPreview === selectedId));
      button.disabled = busy || !masks.some(mask => String(mask.variantId) === button.dataset.stGiftPreview && mask.available);
    });
    const previewMask = masks.find(mask => String(mask.variantId) === selectedId);
    document.querySelectorAll('[data-st-gift-selection]').forEach(label => {
      label.hidden = !previewMask;
      label.textContent = previewMask ? strings.selected + ' : ' + previewMask.name : '';
    });
    document.querySelectorAll('[data-ss-gift-cart-slot]').forEach(holder => {
      if (!holder.querySelector('[data-ss-gift-cart]')) holder.prepend(template.content.cloneNode(true));
    });
    document.querySelectorAll('[data-ss-gift-cart]').forEach(widget => {
      widget.hidden = state.pairs < 1;
      const image = widget.querySelector('[data-ss-gift-cart-image]');
      image.hidden = !model;
      if (model) { image.src = model.image; image.alt = model.name; }
      widget.querySelector('[data-ss-gift-cart-title]').textContent = free ? strings.cart_added : strings.cart_choose;
      widget.querySelector('[data-ss-gift-cart-name]').textContent = model ? model.name : strings.cart_text;
      widget.querySelector('[data-ss-gift-cart-price]').hidden = !free;
      widget.querySelector('[data-ss-gift-open]').textContent = model ? strings.change : strings.choose;
      widget.querySelector('[data-ss-gift-open]').disabled = busy;
    });
  }

  function close() {
    if (busy) return;
    dialog.close();
    if (lastFocus && lastFocus.isConnected) lastFocus.focus({preventScroll:true});
  }

  function open() {
    if (busy || (state.pairs < 1 && !config.productEligible)) return;
    const active = document.activeElement;
    lastFocus = active?.closest?.('cart-drawer')
      ? document.querySelector('[aria-controls="CartDrawer"]:not(.fixed-overlay)')
      : active;
    showStatus('');
    paint();
    // Display the four-mask chooser before starting the drawer hide animation.
    if (!dialog.open) dialog.showModal();
    document.querySelectorAll('quick-view-modal,cart-drawer').forEach(element => {
      if (element.open && typeof element.hide === 'function') element.hide();
    });
  }

  async function reconcile(openAfterAdd = false) {
    const previousPairs = state.pairs;
    state = await readState();
    const lines = gifts(state.cart);
    const updates = {};
    if (state.pairs < 1) {
      lines.forEach(item => { updates[item.key] = 0; });
      if (previousPairs > 0) remember('');
    } else {
      lines.forEach((item,index) => {
        if (index > 0 || item.quantity !== 1) updates[item.key] = index === 0 ? 1 : 0;
      });
    }
    if (Object.keys(updates).length) {
      await update(updates);
      state = await readState();
    }
    observed = signature(state.cart);
    paint();
    if (state.pairs < 1 && dialog.open) close();
    if (!gifts(state.cart).length && state.pairs > 0 && (state.pairs > previousPairs || openAfterAdd)) {
      if (pending && masks.some(mask => String(mask.variantId) === pending && mask.available)) await select(pending);
      else open();
    }
  }

  function enqueue(task) {
    work = work.then(task).catch(error => {
      busy = false;
      showStatus(error.message || strings.error);
      paint();
    });
    return work;
  }

  async function select(variantId, allowPreselect = false) {
    const model = masks.find(mask => String(mask.variantId) === String(variantId) && mask.available);
    if (!model || busy) return;
    state = await readState();
    if (state.pairs < 1) {
      if (!config.productEligible && !allowPreselect) throw new Error(strings.need_pair);
      remember(model.variantId);
      paint();
      showStatus(strings.preselected);
      return;
    }
    // Already selected and free: do not remove/re-add the same gift.
    // Keep the chooser open, with its selected state visible.
    const existingGift = gifts(state.cart).find(item =>
      String(item.variant_id) === String(model.variantId)
    );
    if (existingGift && existingGift.quantity === 1 && existingGift.final_line_price === 0) {
      remember(model.variantId);
      observed = signature(state.cart);
      paint();
      showStatus('');
      return;
    }
    busy = true;
    dialog.querySelectorAll('[data-ss-gift-pick]').forEach(button => {
      button.classList.toggle('ss-gift-picking', button.dataset.ssGiftPick === String(model.variantId));
    });
    showStatus(strings.adding);
    paint();
    try {
      const updates = {};
      gifts(state.cart).forEach(item => { updates[item.key] = 0; });
      updates[String(model.variantId)] = 1;
      await update(updates);
      state = await readState();
      const chosen = gifts(state.cart).find(item => Number(item.variant_id) === Number(model.variantId));
      if (!chosen || chosen.final_line_price !== 0) {
        const remove = {};
        gifts(state.cart).forEach(item => { remove[item.key] = 0; });
        if (Object.keys(remove).length) await update(remove);
        state = await readState();
        throw new Error(strings.discount_error);
      }
      remember(model.variantId);
      observed = signature(state.cart);
      busy = false;
      paint();
      showStatus('');
      close();
      // The mask chooser must not force the cart drawer to reopen.
      document.dispatchEvent(new CustomEvent('sneaktix:gift:selected', {bubbles:true}));
    } catch (error) {
      busy = false;
      paint();
      showStatus(error.message || strings.error);
      if (!dialog.open) open();
      showStatus(error.message || strings.error);
    } finally {
      dialog.querySelectorAll('.ss-gift-picking').forEach(button => button.classList.remove('ss-gift-picking'));
    }
  }

  function cartChanged(event) {
    const cart = event?.cart || event?.detail?.cart;
    if (!cart?.items) return;
    if (signature(cart) === observed) { paint(); return; }
    observed = signature(cart);
    enqueue(() => reconcile(false));
  }

  if (window.FoxTheme?.pubsub) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, cartChanged);
  }
  // Handle the change button before the cart drawer's own click handlers.
  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('[data-ss-gift-open]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (trigger.disabled || busy) return;
    // Opening must be immediate, even when a gift is already in the cart.
    open();
    enqueue(async () => {
      await reconcile(false);
      if (!dialog.open && state.pairs > 0) open();
    });
  }, true);

  // Inline picker (product page and quick-view): no dialog or cart opening.
  // The preview is rendered only for eligible sneakers, so preselection is allowed
  // before a pair has been added to the cart.
  document.addEventListener('click', event => {
    const preview = event.target.closest?.('[data-st-gift-preview]');
    if (!preview) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (preview.disabled || busy) return;
    enqueue(() => select(preview.dataset.stGiftPreview, true));
  }, true);

  document.addEventListener('click', event => {
    const pick = event.target.closest('[data-ss-gift-pick]');
    if (pick) { event.preventDefault(); enqueue(() => select(pick.dataset.ssGiftPick)); return; }
    if (event.target.closest('[data-ss-gift-close]')) close();
  });
  dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    let paintPending = false;
    new MutationObserver(records => {
      if (paintPending || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) return;
      paintPending = true;
      requestAnimationFrame(() => {
        paintPending = false;
        paint();
      });
    }).observe(drawer,{childList:true,subtree:true});
  }
  document.addEventListener('cart:refresh', () => enqueue(() => reconcile(false)));
  window.addEventListener('pageshow', event => { if (event.persisted) enqueue(() => reconcile(false)); });
  paint();
  if (gifts(state.cart).length || (pending && state.pairs > 0)) enqueue(() => reconcile(Boolean(pending)));
})();
